import http from '../httpService';

export function getAllCourtSubcategoryRisks() {
  return http.get(`/court-subcategory-risks`);
}

export function updateCourtSubcategoryRisk(payload) {
  return http.put('/court-subcategory-risks', payload);
}

export function createCourtSubcategoryRisk(payload) {
  return http.post('/court-subcategory-risks', payload);
}

export function deleteCourtSubcategoryRisk(id) {
  return http.delete(`/court-subcategory-risks/${id}`);
}
